import React, { useEffect } from 'react';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';

const TextInput = ({ label, placeholder, unit, value, onChange, name }) => {
    // Ensure the input starts with "0" if it's undefined or empty
    useEffect(() => {
        if (!value || value === "") {
            onChange({ target: { name, value: "0" } });
        }
    }, [value, name, onChange]); // Runs on first render

    // Function to handle input change and enforce whole positive numbers
    const handleInputChange = (e) => {
        let { value } = e.target;

        // Ensure the value is a whole positive number or empty
        const wholeNumber = /^\d*$/; // Regular expression to match whole numbers

        if (wholeNumber.test(value)) {
            // Send "0" to API when empty but display as empty in the field
            onChange({ target: { name, value: value === '' ? '0' : value } });
        }
    };

    return (
        <div>
            <div className="uk-child-width-1-1 uk-child-width-1-3@m uk-flex-middle uk-grid uk-grid-small uk-margin-small-bottom">
                <div className="uk-first-column">
                    <label className="uk-form-label uk-display-block">
                        {label} ({unit})
                    </label>
                </div>
                <div className="uk-width-2-3@m">
                    <div className="uk-flex-middle uk-grid uk-grid-small">
                        <div className="uk-width-expand uk-first-column">
                            <input
                                id="slab-thickness"
                                type="number"
                                placeholder={placeholder}
                                className="uk-text-center custom-input"
                                value={value === "0" ? "" : value} // Display empty when value is "0"
                                onChange={handleInputChange} // Handle the input change
                                min="0" // Allow zero as the minimum value
                                step="1" // Ensure step values are whole numbers
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Inline styles for the placeholder */}
            <style>
                {`
                .custom-input {
                    height: 50px;
                    border: none;
                    background-color: #F6F7F9;
                    color: #666666;
                    font-size: 16px;
                    padding: 0px;
                    transition: all 0.3s ease;
                }

                .custom-input:hover {
                    background-color: #d3e0fa;
                }

                .custom-input:focus {
                    outline: none;
                    border: none;
                    background-color: #d3e0fa;
                }

                .custom-input::placeholder {
                    color: #9ba2ad;
                    opacity: 1;
                }

                /* Compatibility for different browsers */
                .custom-input::-webkit-input-placeholder {
                    color: #9ba2ad;
                }

                .custom-input:-ms-input-placeholder {
                    color: #9ba2ad;
                }

                .custom-input::-moz-placeholder {
                    color: #9ba2ad;
                }
                `}
            </style>
        </div>
    );
};

export default TextInput;
